/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {EViewDataSetErrorsDialogDataType, GreenLineActionTypes} from "../../../../redux/ducks/SensingSystemArchitectureDesign"


/**
 * Renders a string representation of the given GreenLineActionType.
 *
 * @param {GreenLineActionTypes} actionType - The action type to render.
 * @param {boolean} [isBlueLine=false] - Optional flag to indicate if the action is for blue lines.
 * @returns {string} The string representation of the action type.
 */
export function renderGreenLineActionType(
  actionType: GreenLineActionTypes,
  dataType: EViewDataSetErrorsDialogDataType | null
): string {
  let generateMsg = ''
  switch (dataType) {
    case EViewDataSetErrorsDialogDataType.BlueLine:
      generateMsg = "Generate Blue Lines";
      break;
    case EViewDataSetErrorsDialogDataType.Violations:
      generateMsg = "Generate Violations";
      break;
    case EViewDataSetErrorsDialogDataType.GreenLine:
      generateMsg = "Generate Green Lines";
      break;
  }
  switch (actionType) {
    case GreenLineActionTypes.GENERATE:
      return generateMsg;
    case GreenLineActionTypes.COMMONIZE:
      return "Commonize";
    case GreenLineActionTypes.SMOOTH:
      return "Smooth";
    case GreenLineActionTypes.SYMMETRIZE:
      return "Symmetrize";
    default:
      return "unknown action";
  }
}
